import * as React from 'react';

export const  Wordpress =()=> (
<svg version="1.1" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
 <rect x="50" y="50" width="500" height="500" rx="77" ry="77" fill="#05a8da"/>
 <circle cx="306" cy="306" r="182" fill="none" stroke="#fff" stroke-width="20"/>
 <path d="m365 474 28-15 54-156c10-25 13-45 13-62 0-32-13-60-36-63-21-2-33 19-32 31 2 29 31 45 31 85 0 28-18 73-31 117l-62-187 20-1c10 0 9-15-1-14-31 3-60 2-92 0-10-1-10 14-1 14l18 1 27 74-38 114-63-188 20-1c9 0 8-15-1-14-29 2-57 4-64-1l-8 24 84 233 25 14 54-158" fill="#fff"/>
</svg>
)